queryVariables